import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { LayoutModule, BoxModule, BoxInfoModule, AccordionModule, DropdownModule as mkDropdownModule, AlertModule } from 'angular-admin-lte';
import { LoadingPageModule, MaterialBarModule } from 'angular-loading-page';
import { CookieService } from 'ng2-cookies';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AvatarModule  } from 'ngx-avatar';
import { NgxBarcodeModule } from 'ngx-barcode';
import { Daterangepicker } from 'ng2-daterangepicker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { HomeService } from './home/home.service';
import { HttpClient } from "./httpclient";
import { StorageService } from "./auth/storage.service";
import { AuthService } from "./auth/auth.service";
import { RefreshTokenInterceptor } from "./auth/token-interceptor.service";
import { AuthGuard } from "./auth/auth.guard";
import { UsersComponent } from './auth/users/users.component';
import { UsersService } from "./auth/users/users.service";
import { UserDetailComponent } from './auth/users/detail/user-detail.component';
import { GroupsService } from "./auth/groups/groups.service";
import { GroupsComponent } from './auth/groups/groups.component';
import { GroupDetailComponent } from './auth/groups/group-detail/group-detail.component';
import { AssetsService } from "./assets/assets.service";
import { StockComponent } from './assets/stock/stock.component';
import { HistoryComponent } from './assets/history/history.component';
import { NotlocatedComponent } from './assets/notlocated/notlocated.component';
import { StockSummarizedComponent } from './assets/stock/stock-summarized.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { MovementsAuditoryComponent } from './assets/auditory/movement-auditory.component';
import { MovementsDetailComponent } from './assets/auditory/movement-detail.component';
import { LocationsComponent } from './assets/locations/locations.component';
import { LocationsService } from './assets/locations/locations.service';
import { LocationDetailComponent } from './assets/locations/detail/location-detail/location-detail.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    UsersComponent,
    UserDetailComponent,
    GroupsComponent,
    GroupDetailComponent,
    StockComponent,
    HistoryComponent,
    NotlocatedComponent,
    StockSummarizedComponent,
    UserGuideComponent,
    MovementsAuditoryComponent,
    MovementsDetailComponent,
    LocationsComponent,
    LocationDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    BoxModule,
    BoxInfoModule,
    AccordionModule,
    mkDropdownModule,
    AlertModule,
    LayoutModule.forRoot({skin: 'blue'}),
    LoadingPageModule, MaterialBarModule,AngularMultiSelectModule,
    NgxPaginationModule,
    BrowserAnimationsModule,NoopAnimationsModule,
    AvatarModule,
    NgxBarcodeModule,
    Daterangepicker
  ],
  providers: [
    CookieService,
    AuthGuard,
    AuthService,
    StorageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true
    },
    UsersService,
    GroupsService,
    HttpClient,
    HomeService,
    AssetsService,
    LocationsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
